// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalError_header__RT2I3","footer":"ModalError_footer__2w0ZM"};